import { MutationType, ResourceType } from '@tencent/slide-sdk-pb-model';
import { assert } from 'ts-essentials';
import { BaseMutation } from '../base/base-mutation';
import { MutationSource } from '../../constants';
import { Rule } from '../base/mutation-rules';
import type { PresentationDataModel } from '../../model/presentation-data-model';
import type { MaybeError } from '../base/base-mutation';
import type { IValidUpdateResourceMapMutationData } from '../base/valid-mutation-data';

export class UpdateResourceMapMutation extends BaseMutation<
    PresentationDataModel,
    IValidUpdateResourceMapMutationData
> {
    public readonly type: MutationType = MutationType.UpdateResourceMap;

    public apply(presentation: PresentationDataModel) {
        const { resourceType, id, imageDescriptor } = this.data;
        if (resourceType === ResourceType.Image) {
            assert(imageDescriptor, 'imageDescriptor should not be null');
            presentation.store.updateImageResourceMap(id, { id, ...imageDescriptor });
        }

        const { videoDescriptor } = this.data;
        if (resourceType === ResourceType.Video) {
            assert(videoDescriptor, 'videoDescriptor should not be null');
            presentation.store.updateVideoResourceMap(id, { id, ...videoDescriptor });
        }

        const { audioDescriptor } = this.data;
        if (resourceType === ResourceType.Audio) {
            assert(audioDescriptor, 'audioDescriptor should not be null');
            presentation.store.updateAudioResourceMap(id, { id, ...audioDescriptor });
        }

        const { fontDescriptor } = this.data;
        if (resourceType === ResourceType.Font) {
            assert(fontDescriptor, 'fontDescriptor should not be null');
            presentation.store.updateFontResourceMap(id, { id, ...fontDescriptor });
        }
    }

    public invert(): [] {
        return [];
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public check(presentation: PresentationDataModel, source?: MutationSource): MaybeError {
        if (source === MutationSource.Keyframe) return;
        return Rule.resourceMap.id.is.valid(this.data.id);
    }
}
